import GridArea from "../../../../../../src/entities/GridArea";
import { Coord } from "../../../../../../src/types/Interface";
import { GRID_CONFIG, QUESTION_COUNT } from "../../types/Config";
import { Direction, QuestionType } from "../../types/Enum";
import { Question, PointAnswer, ShapeAnswer } from "../../types/Interface";
import { EnumEventBus, eventBus } from "../EventBus";
import checkLinesAnswer from "./helpers/checkLinesAnswer";
import checkPointAnswer from "./helpers/checkPointAnswer";
import { createLinesFromShapeCoord } from "./helpers/createLinesFromShapeCoord";


export default class TestQuestionManager {
  private static instance: TestQuestionManager;
  private Questions: Question[] = [];
  private Answers: (PointAnswer | ShapeAnswer)[] = [];
  private checkedAnswers!: (boolean | null)[];
  private rotation: number = null;
  private direction: Direction = null;

  private constructor() {
    eventBus.on(EnumEventBus.setRotation, (r: number) => this.rotation = r);
    eventBus.on(EnumEventBus.setDirection, (d: Direction) => this.direction = d)
    eventBus.on(EnumEventBus.showResults, () => this.checkAnswer());
  }

  static getInstance = (): TestQuestionManager => {
    if (!TestQuestionManager.instance) TestQuestionManager.instance = new TestQuestionManager();
    return TestQuestionManager.instance;
  };
  getQuestionCount = () => QUESTION_COUNT;
  addQuestion = (q: Question) => this.Questions.push(q);
  getQuestion = (index: number) => this.Questions[index];
  getAnswer = (index: number) => this.Answers[index];
  getAnswersLength = () => this.Answers.length;
  getIsCompleted = () => this.Questions.length == QUESTION_COUNT;

  public addAnswer(answer: { coord: Coord[], id: number }[]) {
    const question = this.Questions[this.Answers.length];
    let ans: PointAnswer | ShapeAnswer;

    if (question.qType == QuestionType.TYPE1) {
      ans = { answer, type: QuestionType.TYPE1 }
    } else if (question.qType == QuestionType.TYPE2) {
      ans = {
        answer,
        type: QuestionType.TYPE2,
        rotation: this.rotation,
        direction: this.direction,
      }
    }
    this.Answers.push(ans);
    this.rotation = this.direction = null;
  }
  reset() {
    this.Questions = [];
    this.Answers = [];
    this.checkedAnswers = [];
  }
  checkAnswer() {
    this.checkedAnswers = [...this.Questions].map((question: Question, qI: number) => {
      if (question.qType == QuestionType.TYPE1 && this.Answers[qI].type == QuestionType.TYPE1) {
        const answer = this.Answers[qI] as ShapeAnswer;
        if (answer.answer.length == 0) { return null }
        const rotShapeCoord = [...question.rotatedShapePoints].map(c => GridArea.getGlobalCoord(GRID_CONFIG, c));
        const qAnsLinesCoords = createLinesFromShapeCoord(rotShapeCoord);
        return checkLinesAnswer(qAnsLinesCoords, answer);
      } else {
        const answer = this.Answers[qI] as PointAnswer;
        if (answer.answer.length === 0 && !answer.direction && !answer.rotation) { return null }
        return checkPointAnswer(question, answer);
      }
    })
    eventBus.emit(EnumEventBus.checkedAnswers, this.checkedAnswers);
  }
}